"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var MusicLink_1 = __importDefault(require("./MusicLink"));
function MusicHeader(_a) {
    var selected = _a.selected;
    return (react_1.default.createElement("div", { className: "row", style: { paddingBottom: '20px' } },
        react_1.default.createElement("div", null,
            react_1.default.createElement(MusicLink_1.default.AlbumsLink, { selected: selected }, "albums")),
        react_1.default.createElement("div", null, "|"),
        react_1.default.createElement("div", null,
            react_1.default.createElement(MusicLink_1.default.ArtistsLink, { selected: selected }, "artists")),
        react_1.default.createElement("div", null, "|"),
        react_1.default.createElement("div", null,
            react_1.default.createElement(MusicLink_1.default.TracksLink, { selected: selected }, "tracks"))));
}
exports.default = MusicHeader;
